import React from "react";
import { Box, Typography } from "@mui/material";

export const Swatch = ({ selectedColor, background, onClick, label }) => {
  const isSelected = selectedColor === background;
  const border = isSelected ? "solid 2px purple" : "solid 2px transparent";
  return (
    <Box
      style={{
        padding: ".5rem",
      }}
    >
      <Box
        onClick={(event) => {
          onClick(event, background);
        }}
        style={{
          position: "relative",
          borderRadius: "50%",
          width: "28px",
          height: "28px",
          border,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          marginTop: "-1rem",
        }}
      >
        <Box
          style={{
            boxShadow: "rgb(0 0 0 / 20%) 0px 0px 0px 1px inset",
            background,
            borderRadius: "50%",
            width: "24px",
            height: "24px",
          }}
        ></Box>
        <Typography
          style={{
            fontSize: "0.5rem",
            color: "black",
            padding: ".5rem 0rem",
            position: "absolute",
            bottom: "-1.4rem",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};
